// GetQuickFilters returns a list of valid quick filters for the current category and applied filters.
//
// It will provide which quick filter is currently active based on the applied filters.
//
// For each of the valid quick filter options, it will also return the product count of that quick filter.
// And it will attach the applied filters which should be selected in case a quick filter is being selected.
//
// For certain quick filters, there will also be additional data attached so the quick filters can be displayed properly.
export const CategoryStreamService_GetQuickFiltersLazy = () =>
  import("./service.grpc").then((m) => m.CategoryStreamService_GetQuickFilters);
CategoryStreamService_GetQuickFiltersLazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetQuickFilters" as const;

// GetGenderSwitch returns a list of Gender Switches which can be displayed in a Product Stream.
// The response tells you the corresponding category details for Male and Female genders, and the product count in them.
export const CategoryStreamService_GetGenderSwitchLazy = () =>
  import("./service.grpc").then((m) => m.CategoryStreamService_GetGenderSwitch);
CategoryStreamService_GetGenderSwitchLazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetGenderSwitch" as const;

// GetProductStream returns a list of items (including products) which should be shown on a category stream.
//
// Due to the fact that we combine multiple data sources we can't ensure that you will get the amount of items you requested.
// E.g. if you request the first 20 items, it can be that you only get 19 back.
export const CategoryStreamService_GetProductStreamLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryStreamService_GetProductStream
  );
CategoryStreamService_GetProductStreamLazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetProductStream" as const;

// GetAdditionalProductStream returns a list of items (including products) which should be shown on an additional category stream.
//
// This is the stream that may include different or additional items for the main one.
// Even if the request parameters will be the same as for GetProductStream the response may be different.
export const CategoryStreamService_GetAdditionalProductStreamLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryStreamService_GetAdditionalProductStream
  );
CategoryStreamService_GetAdditionalProductStreamLazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetAdditionalProductStream" as const;

// GetAdditionalProductStream returns a list of items (including products) which should be shown on an additional category stream.
//
// This is the stream that may include different or additional items for the main one.
// Even if the request parameters will be the same as for GetProductStream the response may be different.
export const CategoryStreamService_GetAdditionalProductStreamV2Lazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryStreamService_GetAdditionalProductStreamV2
  );
CategoryStreamService_GetAdditionalProductStreamV2Lazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetAdditionalProductStreamV2" as const;

// GetProductStreamPage returns a subsequent part of the product stream
// Takes the state from an earlier GetProductStream call, to expose a consistent state over time
export const CategoryStreamService_GetProductStreamPageLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryStreamService_GetProductStreamPage
  );
CategoryStreamService_GetProductStreamPageLazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetProductStreamPage" as const;

// Due to the fact that we combine multiple data sources we can't ensure that you will get the amount of items you requested.
// E.g. if you request the first 20 items, it can be that you only get 19 back.
export const CategoryStreamService_GetProductStreamV2Lazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryStreamService_GetProductStreamV2
  );
CategoryStreamService_GetProductStreamV2Lazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetProductStreamV2" as const;

// GetProductStreamPage returns a subsequent part of the product stream
// Takes the state from an earlier GetProductStream call, to expose a consistent state over time
export const CategoryStreamService_GetProductStreamPageV2Lazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryStreamService_GetProductStreamPageV2
  );
CategoryStreamService_GetProductStreamPageV2Lazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetProductStreamPageV2" as const;

// GetInStreamPersonalizedProducts returns personalized products to be injected into the product stream when returning from an ADP
// Takes the token from an earlier GetProductStreamV2 call to provide personalized products for the given stream
export const CategoryStreamService_GetInStreamPersonalizedProductsLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryStreamService_GetInStreamPersonalizedProducts
  );
CategoryStreamService_GetInStreamPersonalizedProductsLazy.method =
  "aysa_api.services.category_page.v1.stream.CategoryStreamService/GetInStreamPersonalizedProducts" as const;
